module.exports = __webpack_public_path__ + "img/logo-play-store.16c2565c.svg";